var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr',{staticClass:"d-none d-md-block mb-0"}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }